import { useEffect, useState } from "react"
export default function Segundos({ parametros, recebedor, tabStatus, buscarTodosPedidos }) {
    const hasIfood = () => {
        return parametros?.ativaIntegracaoIfood
    }

    const reseteTime = () => {
        if (hasIfood()) {
            return 30
        } else if (recebedor?.buscarAutomaticamenteXSegundos) {
            return recebedor.buscarAutomaticamenteXSegundos
        } else {
            if (tabStatus === "VIEW") {
                return 60
            }
        }

        return 180
    }

    const [time, setTime] = useState(reseteTime())
    useEffect(() => {
        const tempo = setTimeout(() => {
            if (tabStatus !== "OFF") {
                if (time > 0) {
                    setTime(time - 1)
                } else {
                    setTime(reseteTime())
                    buscarTodosPedidos(localStorage.getItem("chaveSistema"))
                }
            }
        }, 1000)
        return () => clearTimeout(tempo)
    }, [tabStatus, recebedor, time])

    return (
        <span>
            <span id="timeAtualizar" style={{ marginLeft: "5px" }}>
                {time}
            </span>
            s
        </span>
    )
}
